// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  serverBaseUrl: '/API/private/',
  serverLoginUrl: '/API/v1.0/REST/token/API/v1.0/REST/token',
  chartsColorPalette: ['#42145F', '#D7D2DB', '#856D94', '#C2BACC', '#C2BACC'],
  brandName: 'mobyt'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
